import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorSession } from "~/models/VendorSession";

const paths = {
	index: "/vendors/sessions"
};

type TIndex = () => SwrReturnType<VendorSession>;
type ReturnType = {
	index: TIndex;
};

export const useSessions = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<VendorSession>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
